import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'edit_department_geo_zone';
export const useEditDepartmentGeoZoneTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Зона на карте',
    edit_button: 'Изменить зону на карте',
    undo: 'Удалить последнюю точку',
    clear: 'Очистить зону',
    color: 'Цвет',
    submit: 'Сохранить',
    cancel: 'Отмена',
    toast_success: 'Зона на карте успешно изменена',
    toast_error: 'Не удалось изменить зону на карте',
    hint_draw: 'Нажмите и удерживайте клавишу Shift чтобы нарисовать зону.',
    hint_delete: 'Нажмите Delete чтобы удалить зону.',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Map zone',
    edit_button: 'Edit map zone',
    undo: 'Remove last point',
    clear: 'Clear zone',
    color: 'Color',
    submit: 'Save',
    cancel: 'Cancel',
    toast_success: 'Map zone updated successfully',
    toast_error: 'Failed to update map zone',
    hint_draw: 'Press and hold the Shift key to draw a zone.',
    hint_delete: 'Press Delete to delete the zone.',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Zona en el mapa',
    edit_button: 'Editar zona en el mapa',
    undo: 'Eliminar el último punto',
    clear: 'Borrar zona',
    color: 'Color',
    submit: 'Guardar',
    cancel: 'Cancelar',
    toast_success: 'Zona en el mapa actualizada con éxito',
    toast_error: 'Error al actualizar la zona en el mapa',
    hint_draw: 'Mantén pulsada la tecla Mayús para dibujar una zona.',
    hint_delete: 'Pulse Delete para borrar la zona.',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Zona no mapa',
    edit_button: 'Editar zona no mapa',
    undo: 'Remover o último ponto',
    clear: 'Limpar zona',
    color: 'Cor',
    submit: 'Salvar',
    cancel: 'Cancelar',
    toast_success: 'Zona no mapa atualizada com sucesso',
    toast_error: 'Falha ao atualizar a zona no mapa',
    hint_draw: 'Pressione e mantenha pressionada a tecla Shift para desenhar uma zona.',
    hint_delete: 'Pressione Delete para excluir a zona.',
  },
}) as Record<string, unknown>;
